
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipNoCommandS as ObiOwnShipNoCommandSElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-no-command-s.js';
 
 
 

 
 export const ObiOwnShipNoCommandS = createComponent({
   react: React,
   tagName: 'obi-own-ship-no-command-s',
   elementClass: ObiOwnShipNoCommandSElement,
   events: {
     
   }
  });
 
 